export default __webpack_public_path__ + "static/media/decoratorLogin.f1da375e.png";